import styled from 'styled-components'

const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');
const buttonColor = props => props.theme.global.colors['dark-2']; //#282832
const whiteColor = props => props.theme.global.colors['white']; //#ffffff
const hoverColor = props => props.theme.global.colors['hoverDarkSecondary']; //#444457
const blueLinkColor = props => props.theme.global.colors['blueLink']; //#05629b

export const RmaDetailLRButtonContainer = styled.div`
  > p:first-child {
    font-size: 14px;
    line-height: 23.1px;
    padding-bottom: 32px;
    margin: 0px;
  }

  > p:nth-child(3) {
    text-align: center;
    font-size: 12px;
    line-height: 19.8px;
    margin: 0px;
    padding: 16px 0px;
  }

  > button:nth-child(2) {
    display: block;
    width: 100%;
    height: 40px;
    background: ${buttonColor};
    border-radius: 4px;
    margin: 0px auto;
    color: ${whiteColor};
    font-size: 16px;
    font-family: 'Roboto';
    font-weight: bold;
    text-align: center;
    letter-spacing: 0px;
    line-height: 26.4px;
    cursor: pointer;
    border: none;
    padding: 0px;

    &:hover {
      background-color: ${hoverColor};
    }
  }

  ${tabletBreakpoints}{
    p {
        width: 100%;
        margin: unset;
    }
        button:nth-child(2) {
        width: 292px;
    }
  }
`

export const ReturnLink = styled.div`
    text-align: center;
    >span{
        color: ${blueLinkColor};
        cursor: pointer;
        font-size: 14px;
        line-height: 165%;
        text-decoration-line: underline;
    }
    
`

export const RmaDetailLRPrintSlip = styled.button`
    display: block;
    width: 100%;
    height: 40px;
    background: ${buttonColor};
    border-radius: 4px;
    margin: 0px auto;
    color: ${whiteColor};
    font-size: 16px;
    font-family: 'Roboto';
    font-weight: bold;
    text-align: center;
    letter-spacing: 0px;
    line-height: 26.4px;
    cursor: pointer;
    border: none;
    padding: 0px;

    &:hover {
      background-color: ${hoverColor};
    }

    ${tabletBreakpoints}{
      width: 292px;
    }
`
